<template>
  <!-- template for the modal component -->
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper" style="height:100vh">
        <v-card class="modal-container text-center mb-5" width="90vw" :max-width="$vuetify.breakpoint.xl ? 1400 : 1000">

          <v-card elevation="0" class="text-center">
            <v-btn elevation="0" fab color="error" small class="modal-default-button title"
              @click="$emit('close'), error = null">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <div v-if="!$vuetify.breakpoint.xl" class="ma-2 float-right">
              <v-btn elevation="0" class="float-left mb-1 mr-1" width="110px" color="#465169" small dark
                @click="scrollTop"><v-icon>mdi-chevron-up</v-icon></v-btn>
              <v-btn elevation="0" class="float-right mb-1" width="110px" color="#465169" small dark
                @click="scrollDown"><v-icon>mdi-chevron-down</v-icon></v-btn>
            </div>
            <div style="clear:both"></div>
            <div>
              <v-card-text class="headline">
                Transaction History
              </v-card-text>
              <v-card-subtitle class="mt-n6">From: {{ moment().startOf('day').format('LLLL') }} <br>For user: {{ userName }}
                at Terminal: {{ getTerminalLocation }}</v-card-subtitle>
              <div style="clear:both"></div>
              <v-card-text v-if="error">
                {{ error }}
              </v-card-text>
            </div>
            <v-progress-linear v-if="wait" indeterminate color="cyan" width="100%"></v-progress-linear>
            <v-simple-table :dense="!$vuetify.breakpoint.xl" :fixed-header="true" height="500" class="transactionTable">
              <thead>
                <tr class="">
                  <th class="text-left">Time</th>
                  <th class="text-left">Reason</th>
                  <th class="text-left">Reference</th>
                  <th class="text-left">Type</th>
                  <th class="text-right">Amount $</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(t, index) in transHistory" :key="index" @click="openTicketInfo(t.ticketId)" >
                  <td class="text-left">{{ localTime(t.created) }}</td>
                  <td class="text-left">{{ t.reason || '-' }} <span v-if="t.reprint"> Reprinted </span></td>
                  <td class="text-left">{{ formatReference(t.reference) || '-' }}</td>
                  <td class="text-left">{{ adjType[t.type] }}</td>
                  <td :class="t.amount > 0 ? 'text-right success--text':'text-right red--text'">{{ formatMoney(t.amount) }}</td>
                </tr>
              </tbody>
            </v-simple-table>
            <v-simple-table dense>
              <thead>
                <tr class="">
                  <th class="text-left">Tickets Sold <strong>{{ calcSoldValue() }}</strong> </th>
                  <th class="text-left">Tickets Cashed <strong>{{ calcPaidValue() }}</strong></th>
                  <th class="text-left">Draws <strong>{{ calcDrawsValue() }}</strong></th>
                  <th class="text-right">Returns <strong>{{ calcReturnsValue() }}</strong></th>
                  <th class="text-right">Deposits <strong>{{ calcDepValue() }}</strong></th>
                  <th class="text-right">Withdraws <strong>{{ calcWithdrawValue() }}</strong></th>
                  <th class="text-right">Refunded <strong>{{ calcCancValue() }}</strong></th>
                  <th v-if="redemptionCount > 0" class="text-right">Redeemed <strong>{{ redemptionCount }}</strong></th>
                  <th class="text-right">CASH BALANCE</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td :class="calcSold() > 0 ? 'text-left success--text':'text-left red--text'" >{{ formatMoney(calcSold()) }}</td>
                  <td :class="calcPaid() > 0 ? 'text-left success--text':'text-left red--text'" >{{ formatMoney(calcPaid()) }}</td>
                  <td :class="calcDraws() > 0 ? 'text-left success--text':'text-left red--text'" >{{ formatMoney(calcDraws()) }}</td>
                  <td :class="calcReturns() > 0 ? 'text-right success--text':'text-right red--text'">{{ formatMoney(calcReturns()) }}</td>
                  <td :class="calcDeposits() > 0 ? 'text-right success--text':'text-right red--text'">{{ formatMoney(calcDeposits()) }}</td>
                  <td :class="calcWithdrawal() > 0 ? 'text-right success--text':'text-right red--text'">{{ formatMoney(calcWithdrawal()) }}</td>
                  <td class="text-right">{{ formatMoney(calcCancelled()) }}</td>
                  <td v-if="redemptionCount > 0" :class="totalRedemptionAmt > 0 ? 'text-right success--text':'text-right red--text'">{{ formatMoney(totalRedemptionAmt) }}</td>
                  <td class="text-right font-weight-bold">{{ formatMoney(calcTotal()) }}</td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
        </v-card>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from 'axios'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import { adjType } from '../common/constants'
import { PRICE_DISPLAY } from '../common/constants'

export default {
  data() {
    return {
      transHistory: [],
      error: null,
      adjType,
      wait: true
    }
  },
  props: {
    onBarcodeEntered: Function,
    userName: String
  },
  computed: {
    ...mapGetters(['getTerminalId', 'getTerminalLocation', 'getVenueName']),
    redemptionCount() {
      return this.transHistory?.filter(item => item.type === 'VOUCHER_REDEEMED' && item.amount < 0)?.length

    },
    totalRedemptionAmt(){
      let filterTransactions = this.transHistory?.filter(item => item.type === 'VOUCHER_REDEEMED' && item.amount < 0 )
      const total = filterTransactions.reduce((acc, item) => acc + parseFloat(item.amount), 0)
      return Number(total.toFixed(2)) || 0
    }
  },
  created() {
    this.getTransactionHistory()
  },
  methods: {
    ...mapActions(["getTerminalToken"]),
    formatReference(referenceStr){
      if (referenceStr?.indexOf(" win ") != -1){
        return referenceStr?.replace(" win ",` ${PRICE_DISPLAY.find(p=>p.platformType == "win" && p.venueName == this.getVenueName)?.betType} `)
      }else if (referenceStr?.indexOf(" us_place ") != -1){
        return referenceStr?.replace(" us_place ",` ${PRICE_DISPLAY.find(p=>p.platformType == "us_place" && p.venueName == this.getVenueName)?.betType} `)
      } else if (referenceStr?.indexOf(" place ") != -1){
        return referenceStr?.replace(" place ", ` ${PRICE_DISPLAY.find(p=>p.platformType == "place" && p.venueName == this.getVenueName)?.betType} `)
      }
      return referenceStr
    },
    openTicketInfo(v) {
      if (v) {
        const ticketId = v.replace(/-/g, "")
        //state that this is not from scan ticket
        this.onBarcodeEntered(ticketId, false)
        this.$emit('close')
      }
    },
    scrollTop() {
      let content = document.querySelector(".v-data-table__wrapper")
      content.scrollTop -= 50
    },
    scrollDown() {
      let content = document.querySelector(".v-data-table__wrapper")
      content.scrollTop += 50
    },
    moment,
    calcSold() {
      let filterTransactions = this.transHistory?.filter((item) => {
        return (item.type === 'BET_CASH_IN')
      })
      const total = filterTransactions.reduce((acc, item) => acc + parseFloat(item.amount), 0);
      return Number(total.toFixed(2)) || 0
    },
    calcSoldValue() {
      let filterTransactions = this.transHistory?.filter((item) => {
        return (item.type === 'BET_CASH_IN')
      })
      const data = filterTransactions?.length
      return data
    },
    calcCancValue() {
      let filterTransactions = this.transHistory?.filter((item) => {
        return (item.type === 'BET_CANCELLED' || item.type === 'BET_REFUNDED' || item.type === 'BET_REJECTED')
      })
      const data = filterTransactions?.length
      return data
    },
    calcPaid() {
      let filterTransactions = this.transHistory?.filter((item) => {
        return (item.type === 'BET_PAYOUT')
      })
      const total = filterTransactions.reduce((acc, item) => acc + parseFloat(item.amount), 0);
      return Number(total.toFixed(2)) || 0
    },
    calcPaidValue() {
      let filterTransactions = this.transHistory?.filter((item) => {
        return (item.type === 'BET_PAYOUT')
      })
      const data = filterTransactions?.length
      return data
    },
    calcDepValue() {
      let filterTransactions = this.transHistory?.filter((item) => {
        return (item.type === 'CLIENT_DEPOSIT')
      })
      const data = filterTransactions?.length
      return data
    },
    calcWithdrawValue() {
      let filterTransactions = this.transHistory?.filter((item) => {
        return (item.type === 'CLIENT_WITHDRAWAL')
      })
      const data = filterTransactions?.length
      return data
    },
    calcDeposits() {
      let filterTransactions = this.transHistory?.filter((item) => {
        return (item.type === 'CLIENT_DEPOSIT' && item.amount > 0)
      })
      const total = filterTransactions.reduce((acc, item) => acc + parseFloat(item.amount), 0);
      return Number(total.toFixed(2)) || 0
    },
    calcWithdrawal() {
      let filterTransactions = this.transHistory?.filter((item) => {
        return (item.type === 'CLIENT_WITHDRAWAL' && item.amount < 0)
      })
      const total = filterTransactions.reduce((acc, item) => acc + parseFloat(item.amount), 0);
      return Number(total.toFixed(2)) || 0
    },
    calcCancelled() {
      let filterTransactions = this.transHistory?.filter((item) => {
        return (item.type === 'BET_CANCELLED' || item.type === 'BET_REFUNDED' || item.type === 'BET_REJECTED')
      })
      const total = filterTransactions.reduce((acc, item) => acc + parseFloat(item.amount), 0);
      return Number(total.toFixed(2)) || 0
    },
    calcDraws() {
      let filterTransactions = this.transHistory?.filter((item) => {
        return (item.type === 'FLOAT_ADJUSTMENT' && item.amount > 0)
      })
      const total = filterTransactions.reduce((acc, item) => acc + parseFloat(item.amount), 0);
      return Number(total.toFixed(2)) || 0
    },
    calcReturns() {
      let filterTransactions = this.transHistory?.filter((item) => {
        return ((item.type === 'FLOAT_ADJUSTMENT') && item.amount < 0)
      })
      const total = filterTransactions.reduce((acc, item) => acc + parseFloat(item.amount), 0);
      return Number(total.toFixed(2)) || 0
    },
    calcReturnsValue() {
      let filterTransactions = this.transHistory?.filter((item) => {
        return ((item.type === 'FLOAT_ADJUSTMENT') && item.amount < 0)
      })
      const data = filterTransactions?.length
      return data
    },
    calcDrawsValue() {
      let filterTransactions = this.transHistory?.filter((item) => {
        return ((item.type === 'FLOAT_ADJUSTMENT') && item.amount > 0)
      })
      const data = filterTransactions?.length
      return data
    },
    formatMoney(v){
      return v < 0 ? `-$${parseFloat(v*-1).toFixed(2)}`:`$${parseFloat(v).toFixed(2)}`
    },

    calcTotal() {
      const sold = this.calcSold()
      const paid = this.calcPaid()
      const draws = this.calcDraws()
      const returns = this.calcReturns()
      const cancelled = this.calcCancelled()
      const deposits = this.calcDeposits()
      const withdrawals = this.calcWithdrawal()
      const total = (sold + draws + returns + paid + cancelled + deposits + withdrawals + this.totalRedemptionAmt)
      return total.toFixed(2)
    },
    localTime(v) {
      return moment(v).format('h:mm:ss a')
    },
    async getTransactionHistory() {
      const todayDate = moment().startOf('day').format()
     
      const terminalToken = await this.getTerminalToken()
      await axios.post(`${process.env.VUE_APP_LEDGER_ENDPOINT}public/GetTransactions`, {
        terminal_id: terminalToken,
        trans_date: todayDate,
      }
        )
        .then((result) => {
          this.wait = false
          const transac = result.data.TxnDetails
          const sorted = transac.sort((a, b) => { return (new Date(b.created)).getTime() - (new Date(a.created)).getTime() })
          this.transHistory = sorted
        })
        .catch((err) => {
          this.error = err.response.data
        })
    }
  }
}
</script>

<style sccoped>
.transactionsBody {
  max-height: 200px;
  overflow-y: auto;
  overflow-x: hidden
}
</style>
